export default __webpack_public_path__ + "8940c12c0cfdf245f3d9edc483a58ae2.json";